(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jwa-about"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (scope) => {
    scope.querySelectorAll('.ja-series-gallery').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const track = gallery.querySelector('.ja-series-track');
      const controls = gallery.querySelector('.ja-series-controls');
      const prev = controls.querySelector('[data-ja-prev]');
      const next = controls.querySelector('[data-ja-next]');
      const sync = () => {
        const max = track.scrollWidth - track.clientWidth;
        controls.hidden = max <= 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
      };
      const move = (direction) => {
        const card = track.querySelector('.ja-series-card');
        if (!card) return;
        track.scrollBy({left: direction * (card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      prev.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', sync, {passive:true});
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();move(event.key === 'ArrowRight' ? 1 : -1);
      });
      const observer = new ResizeObserver(sync);observer.observe(track);sync();
      document.addEventListener('shopify:section:unload', event => {if(event.target.contains(gallery)) observer.disconnect();});
    });
  };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true}); else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jwa-digital-studio-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const header = root.querySelector('[data-jwa-header]');
      const menu = root.querySelector('[data-jwa-menu]');
      const openMenu = root.querySelector('[data-jwa-menu-open]');
      const closeMenu = root.querySelector('[data-jwa-menu-close]');
      const stage = root.querySelector('.jwa-art-stage');
      const cards = [...root.querySelectorAll('.jwa-art-card[href]')];
      const hint = root.querySelector('[data-jwa-hint]');
      const intro = root.querySelector('.jwa-hero__lead');
      const finePointer = matchMedia('(hover:hover) and (pointer:fine)').matches;
      let active = null;
      let pointerStart = null;

      const syncHeader = () => {
        const hero = root.querySelector('.jwa-hero');
        header?.classList.toggle('is-solid', window.scrollY > Math.max(80, (hero?.offsetHeight || 0) - 72));
      };
      const setMenu = (isOpen) => {
        if (!menu || !openMenu) return;
        menu.hidden = !isOpen;
        openMenu.setAttribute('aria-expanded', String(isOpen));
        document.documentElement.style.overflow = isOpen ? 'hidden' : '';
      };
      syncHeader();
      window.addEventListener('scroll', syncHeader, { passive: true });
      openMenu?.addEventListener('click', () => setMenu(true));
      closeMenu?.addEventListener('click', () => setMenu(false));
      menu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false)));

      root.querySelectorAll('.jwa-series').forEach((seriesSection) => {
      const seriesTrack = seriesSection.querySelector('.jwa-series-grid');
      const seriesControls = seriesSection.querySelector('.jwa-series-controls');
      if (seriesTrack && seriesControls) {
        const previous = seriesControls.querySelector('[data-series-prev]');
        const next = seriesControls.querySelector('[data-series-next]');
        const syncSeries = () => {
          const max = seriesTrack.scrollWidth - seriesTrack.clientWidth;
          seriesControls.hidden = max <= 2;
          previous.disabled = seriesTrack.scrollLeft <= 2;
          next.disabled = seriesTrack.scrollLeft >= max - 2;
        };
        const moveSeries = (direction) => {
          const card = seriesTrack.querySelector('.jwa-series-card');
          const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(seriesTrack).columnGap);
          seriesTrack.scrollBy({left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        };
        previous.addEventListener('click', () => moveSeries(-1));
        next.addEventListener('click', () => moveSeries(1));
        seriesTrack.addEventListener('scroll', syncSeries, {passive:true});
        seriesTrack.addEventListener('keydown', (event) => {
          if (event.target !== seriesTrack || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          moveSeries(event.key === 'ArrowRight' ? 1 : -1);
        });
        const seriesObserver = new ResizeObserver(syncSeries);
        seriesObserver.observe(seriesTrack);
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.target.contains(root)) seriesObserver.disconnect();
        });
        syncSeries();
      }
      });

      if (!stage || !cards.length) return;
      const mobileHint = 'Glissez · Touchez pour agrandir';
      const resetHint = () => { if (hint) hint.textContent = finePointer ? root.dataset.hintBrowse : mobileHint; };
      if (!finePointer) {
        if (intro) intro.textContent = 'Faites glisser les œuvres. Touchez-en une pour l’agrandir, puis une seconde fois pour la découvrir.';
        resetHint();
      }
      const activate = (card, pointer) => {
        active = card;
        const activeIndex = card ? cards.indexOf(card) : -1;
        stage.classList.toggle('has-active', Boolean(card));
        cards.forEach((item, index) => {
          item.classList.toggle('is-active', item === card);
          if (!card) {
            item.style.setProperty('--jwa-push-x', '0px');
            item.style.setProperty('--jwa-push-y', '0px');
            item.style.setProperty('--jwa-tilt-x', '0deg');
            item.style.setProperty('--jwa-tilt-y', '0deg');
          } else if (item === card) {
            const rect = item.getBoundingClientRect();
            const dx = pointer ? (pointer.x - (rect.left + rect.width / 2)) / Math.max(rect.width, 1) : 0;
            const dy = pointer ? (pointer.y - (rect.top + rect.height / 2)) / Math.max(rect.height, 1) : 0;
            item.style.setProperty('--jwa-push-x', `${Math.max(-9, Math.min(9, dx * 9))}px`);
            item.style.setProperty('--jwa-push-y', `${Math.max(-22, Math.min(-12, -18 + dy * 5))}px`);
            item.style.setProperty('--jwa-tilt-x', `${Math.max(-5, Math.min(5, -dy * 5))}deg`);
            item.style.setProperty('--jwa-tilt-y', `${Math.max(-6, Math.min(6, dx * 6))}deg`);
          } else {
            const distance = Math.abs(index - activeIndex);
            const direction = index < activeIndex ? -1 : 1;
            item.style.setProperty('--jwa-push-x', `${direction * Math.max(30, 96 - (distance - 1) * 11)}px`);
            item.style.setProperty('--jwa-push-y', '0px');
            item.style.setProperty('--jwa-tilt-x', '0deg');
            item.style.setProperty('--jwa-tilt-y', '0deg');
          }
        });
      };
      if (finePointer) {
        cards.forEach((card) => {
          card.addEventListener('focus', () => activate(card));
          card.addEventListener('blur', () => activate(null));
        });
        stage.addEventListener('pointermove', (event) => {
          const card = event.target.closest('.jwa-art-card[href]');
          activate(card, card ? { x: event.clientX, y: event.clientY } : null);
        });
        stage.addEventListener('pointerleave', () => activate(null));
      } else {
        stage.addEventListener('pointerdown', (event) => {
          pointerStart = { x: event.clientX, y: event.clientY };
        }, { passive: true });
        stage.addEventListener('pointercancel', () => { pointerStart = null; }, { passive: true });
        stage.addEventListener('click', (event) => event.preventDefault());
        stage.addEventListener('pointerup', (event) => {
          const card = event.target.closest('.jwa-art-card[href]');
          if (!card) { activate(null); return; }
          const moved = pointerStart ? Math.hypot(event.clientX - pointerStart.x, event.clientY - pointerStart.y) : 0;
          pointerStart = null;
          if (moved > 10) {
            activate(null);
            resetHint();
            return;
          }
          if (active === card) { window.location.assign(card.href); return; }
          activate(card);
          card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          if (hint) hint.textContent = root.dataset.hintOpen;
        });
      }
    };

    const boot = (scope = document) => {
      if (scope.matches?.('.jwa-studio')) init(scope);
      scope.querySelectorAll('.jwa-studio').forEach(init);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
    else boot();
    document.addEventListener('shopify:section:load', (event) => boot(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
